import { motion } from "framer-motion";
import { FadeUp, EASE } from "@/components/Reveal";

const Raizes = () => (
  <section data-testid="raizes-section" className="relative overflow-hidden bg-sand/60 py-20 lg:py-32">
    <motion.img
      src="/assets/tree-mark.png"
      alt=""
      aria-hidden="true"
      initial={{ opacity: 0, scale: 0.96 }}
      whileInView={{ opacity: 0.08, scale: 1 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 1.8, ease: EASE }}
      className="pointer-events-none absolute -right-24 top-1/2 w-[420px] -translate-y-1/2 lg:right-10 lg:w-[560px]"
    />
    <div className="container-x relative">
      <FadeUp>
        <p className="eyebrow" data-testid="raizes-eyebrow">A identidade</p>
      </FadeUp>
      <FadeUp delay={0.08}>
        <h2 className="mt-5 max-w-2xl font-serif text-3xl font-light leading-[1.12] tracking-tight text-ink sm:text-4xl lg:text-5xl" data-testid="raizes-title">
          Por que <em className="italic text-raiz-700">Raízes?</em>
        </h2>
      </FadeUp>
      <FadeUp delay={0.16} className="mt-8 max-w-2xl space-y-5">
        <p className="text-base leading-relaxed text-ink/70 md:text-lg">
          Raízes representam história, sustentação e desenvolvimento.
        </p>
        <p className="text-base leading-relaxed text-ink/70">
          Raízes é a identidade que traduz este trabalho: a proposta de um espaço profissional de escuta e compreensão, que respeita aquilo que constitui cada pessoa — sua história, seu contexto, suas relações e sua maneira singular de estar no mundo.
        </p>
      </FadeUp>
      <FadeUp delay={0.24} className="mt-10 flex flex-wrap gap-x-8 gap-y-3">
        {["História", "Sustentação", "Desenvolvimento"].map((w) => (
          <span key={w} className="font-serif text-lg italic text-raiz-700">{w}</span>
        ))}
      </FadeUp>
    </div>
  </section>
);

export default Raizes;
